import { render, staticRenderFns } from "./Historie.vue?vue&type=template&id=5e4e5544&"
import script from "./Historie.vue?vue&type=script&lang=js&"
export * from "./Historie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports